export class WLog {
    constructor(
        data={
            id: -1,
            value: '',
            dateCreated: [],
            dateCreatedFormatted: '',
            dateCreatedFormattedWithYear: ''
        }
    ) {
        this.id = data.id;
        this.value = data.value;
        this.dateCreated = data.dateCreated;
        this.dateCreatedFormatted = data.dateCreatedFormatted;
        this.dateCreatedFormattedWithYear = data.dateCreatedFormattedWithYear;
    }

    getId() {
        return this.id;
    }

    getValue() {
        return this.value;
    }

    getDateCreated() {
        return this.dateCreated;
    }

    getDateCreatedFormatted() {
        return this.dateCreatedFormatted;
    }

    getDateCreatedFormattedWithYear() {
        return this.dateCreatedFormattedWithYear;
    }
}
